import { UIMarket } from '@drift/common';
import { useMemo } from 'react';

export const useSpotMarkets = () => {
	return useMemo(() => UIMarket.spotMarkets, [UIMarket.spotMarkets.length]);
};
